<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          电站无人值守自主移动巡检机器人
        </div>
        <div class="txt">
          Unattended autonomous mobile inspection robot for power stations
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>无人值守巡检机器人项目成果由国网上海市电力公司市区供电公司运检部于2018年2月起在自忠变电站配电室内部署应用。</p>
          <p>
       应用结果达到了预期目标，无人值守巡检机器人系统中机器人运动结构稳定可靠，动作灵活。无人值守巡检机器人控制系统实现了设备定位，对环境温度、氧气浓度、周围声音、巡检实时视频、热成像视频采集与显示、巡检任务自动执行、自主充电等功能，实现了对相应的数据进行记录、分析、存储，并对异常环境参数进行简单分析判断并提供实时报警。无人值守巡检机器人系统对各数据的记录、存储、分析功能也为管理工作提供了改进的数据支持。</p>
        </div> 
      </div>
      <div>
        <div class="title">产品图片</div> 
        <div class="img_one">
          <div class="list_one">
            <img src="../assets/pic51.png" alt="">
          </div>
          <div class="list_one">
            <img src="../assets/pic53.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic54.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one" style="marginTop: 10px">
            <img src="../assets/pic55.png" alt="">
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one .one img {
  width: 1000px;
  height: 450px;
}
.img_one img {
  width: 430px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail8.vue